<template>
    <div>
        <!--<div class="nav">作业详细</div>-->

        <!--<div class="newheight"></div>-->

        <div class="show">
            <div class="task-list">
                <div class="task-img"><img :src="imgprefix+readPic[0].pic"></div>
                <div class="task-name">
                    <span><img :src="imgprefix+readMess.photo"></span>
                    <b>{{readMess.nickName}}({{readMess.author}})</b>
                    <em>{{readMess.viewTime}}</em>
                </div>

                <div class="task-fun">
                    <span class="foleft">
                        <span @click="praise(readMess.praiseFlag,readMess.praiseNum)">
                            <img :src="readMess.praiseFlag== ''?'img/dz.png':'img/y_dz.png'">{{readMess.praiseNum || ''}}
                        </span>
                        <span @click="collect(readMess.collectFlag)">
                            <img :src="readMess.collectFlag== ''?'img/sc.png':'img/y_sc.png'">
                        </span>
                    </span>
                    <span class="foright" @click="reply('-1')">
                        <img src="img/xx.png">{{readMess.talkNum || ''}}
                    </span>
                </div>
            </div>


            <div class="p-list">

                <div class="p-con clearfiex" v-for="(item,index) of replys" :key="item.id">
                    <div class="p-head"><img :src="imgprefix+item.replyPhoto"></div>
                    <div class="p-right">
                        <span><a href="javaScript:void(0)" v-if="item.returnName ==''">{{item.replyName}}</a>
                              <a href="javaScript:void(0)" v-if="item.returnName!=''">{{item.replyName}} 回复 {{item.returnName}}</a>
                             <a v-if="item.disUserId == userId" class="del" href="javaScript:void(0)" @click="deleteReply(item.id)">删除</a>
                        </span>
                        <div class="p-txt" @click="reply(index)">{{item.content}}</div>
                        <div class="p-time">{{item.replyTime}}</div>
                    </div>
                </div>


            </div>


        </div>

        <div style="height: 30px"></div>

        <div class="tfayan">
            <input name="" type="text" v-model="replyValue" class="f-txt clearfiex"
                   :placeholder="replyUserId?('回复'+replyName+':'):'请输入'">
            <input name="" type="button" class="f-but" value="发送" @click="commit">
        </div>
    </div>
</template>

<script>
    import {Toast} from "mint-ui";

    export default {
        name: "taskDetail",
        data() {
            return {
                imgprefix: C.imgprefix,
                title: '作业详情', //导航栏 中间的标题
                replys: [], //回复数据
                userId: this.$route.query.userId, //当前登录人id
                info: {
                    readId: this.$route.query.courseId,
                    disUserId: '',
                    content: '',
                    replyFlag: 1
                },
                taskId: this.$route.query.taskId,
                readMess: {},
                preIndex: this.$route.query.preIndex,
                readPic: [],
                replyUserId: '',
                replyName: '',
                replyValue: ''
            };
        },
        created() {
            this.getReply()
        },
        methods: {

            getReply: function () {
                let {taskId, userId} = this;
                //获取作业详情
                R.Course.getReplyList({
                    id: taskId,
                    userId: userId,
                    dataFlag: 1
                }).then(result => {

                    let {
                        readMess,
                        praises,
                        readPic,
                        replys
                    } = result
                    this.readMess = readMess;
                    this.readPic = readPic;
                    this.replys = replys;
                    this.praises = praises
                })

            },
            reply: function (num) {
                //点击内容
                let replyVo = this.replys[num];
                if(num != '-1'){
                    this.replyUserId = replyVo.disUserId;
                    this.replyName = replyVo.replyName;
                    this.pid = replyVo.id;
                }else{
                    this.replyValue = '';
                    this.replyFlag = '1';
                    this.replyUserId = '';
                    this.pid = '';
                }

            },
            //点赞|取消赞
            praise: function (praiseflag, praisenum) {
                let {
                    taskId, clickFlag = false, userId
                } = this;

                let type = 2
                if (clickFlag) {
                    return
                }
                this.clickFlag = true;

                praisenum--
                if (praiseflag == '') { //未点过赞
                    type = 1
                    praisenum = praisenum + 2
                }
                R.Course.setPraise({
                    readId: taskId,
                    userId: userId,
                    type
                }).then(result => {
                    console.log(result.code);
                    this.readMess.praiseFlag = type == 1 ? '1' : '';
                    this.readMess.praiseNum = praisenum;
                    this.clickFlag = false;
                })


            },

            //收藏|取消
            collect: function (collectFlag) {
                let {
                    taskId, clickFlag = false, userId
                } = this, type = 2
                if (clickFlag) {
                    return
                }
                this.clickFlag = true;
                if (collectFlag == '') { //未收藏过
                    type = 1
                }

                R.Course.taskCollect({
                    readId: taskId,
                    userId: userId,
                    type
                }).then(result => {
                    console.log(result)
                    this.readMess.collectFlag = type == 1 ? '1' : '';

                    this.clickFlag = false;
                })


            },

            //提交
            commit: function () {
                //游客不可进行评论
                if (this.roleType == '4') {
                    Toast('您无权限发表内容');

                    return;
                }

                let {
                    taskId,
                    replyValue = '',
                    pid = '',
                    replyFlag = 1,
                    replyUserId = '',
                    userId
                } = this
                if (!replyValue) {
                    Toast('请输入内容');

                    return;
                }
                R.Course.setReply({
                    readId: taskId,
                    disUserId: userId,
                    content: replyValue,
                    replyFlag,
                    replyUserId,
                    pid
                }).then(result => {
                    console.log(result)
                    this.replyValue = '';
                    this.replyFlag = '1';
                    this.replyUserId = '';
                    this.pid = '';

                    this.getReply()
                })


            },
            deleteReply: function (id) {
                R.Course.deleteReply({
                    id,
                    disUserId: this.userId,
                    readId: this.taskId
                }).then(result => {
                    console.log(result)
                    Toast("删除成功");
                    this.getReply();

                })

            }
        }
    }
</script>

<style scoped>
    body {
        background: #fff;
    }

    .newheight {
        height: 48px;
    }

    .nav {
        height: 48px;
        padding-top: 20px;
        width: 100%;
        position: fixed;
        top: 0;
        text-align: center;
        display: flex;
        flex-direction: row;
        z-index: 9999;
        background: #F8F8F8;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 24px;
        margin: 0;
        padding: 0;
        font-weight: 600;
    }

    .show {
        padding: 12px;
    }

    .task-list {
        border-bottom: 1px solid #e4e4e4;
        padding-bottom: 15px;
    }

    .task-img {
        border-radius: 6px;
        overflow: hidden
    }

    .task-list img {
        width: 100%;
        border-radius: 6px;
    }

    .task-name {
        height: 45px;
        line-height: 45px;
    }

    .task-name span {
        width: 24px;
        height: 24px;
        border-radius: 100px;
        overflow: hidden
    }

    .task-name span img {
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 100px;
        position: relative;
        top: 5px;
    }

    .task-name b {
        font-size: 14px;
        color: #000;
        font-weight: normal;
    }

    .task-name em {
        float: right;
        font-size: 12px;
        color: #666666;
    }

    .task-fun {
        height: 25px;
    }

    .task-fun {
    }

    .foleft {
        float: left;
    }

    .foright {
        float: right
    }

    .task-fun span.foright span {
        display: inline-block;
        height: 25px;
        font-size: 14px;
        color: #000000;
    }

    .task-fun span.foleft span {
        display: inline-block;
        height: 25px;
        font-size: 14px;
        color: #000000;
        margin-right: 19px
    }

    .task-fun span img {
        width: 23px;
        position: relative;
        top: 4px;
    }

    .p-list {
    }

    .p-con {
        border-bottom: 1px solid #e0e1e3;
        padding-top: 15px;
        padding-bottom: 5px;
    }

    .p-head {
        width: 32px;
        height: 32px;
        border-radius: 100px;
        overflow: hidden;
        float: left;
    }

    .p-head img {
        width: 32px;
        height: 32px;
        border-radius: 100px
    }

    .p-right {
        float: right;
        width: calc(100% - 44px);
    }

    .p-right span {
        display: block;
        height: 15px;
        line-height: 15px;
        font-size: 14px;
    }

    .p-right span a {
        font-size: 14px;
        float: left;
        color: #5b6aff;
    }

    .p-right span a.del {
        float: right;
        color: #353535
    }

    .p-txt {
        font-size: 14px;
        color: #353535;
        margin-top: 7px;
        line-height: 16px;
    }

    .p-time {
        font-size: 11px;
        color: #353535;
        margin-top: 5px;
    }

    .tfayan {
        height: 40px;
        background: #ffffff;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
        width: 100%;
        box-shadow: 0 0 15px rgba(33, 33, 33, 0.3)
    }

    .tfayan input.f-but {
        display: block;
        width: 60px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        color: #32a658;
        font-weight: bold;
        float: right;
        background: none;
        border: none
    }

    .tfayan input.f-txt {
        display: block;
        width: calc(100% - 62px);
        float: left;
        line-height: 40px;
        text-indent: 15px;
        font-size: 14px;
        color: #353535;
        border-right: 1px solid #b2b2b2
    }
</style>
